import { TextByType } from './types';

export const text: TextByType = {
  DTF: {
    impression: {
      description: { last: 'Total Production', weekDay: 'Total Production' },
      statsDescription: { last: 'From last week', weekDay: 'From last week' },
      chart: {
        day: 'Total Production',
        week: 'Total Production',
      },
    },
    productionRate: {
      description: { last: 'Current prod. rate', weekDay: 'Average prod. rate' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Avg. Utilization',
      lower: 'Preparation',
      chart: {
        day: 'Total Production by Hour',
        week: 'Average Production by Day',
      },
    },
    utilization: {
      chart: {
        day: 'Utilization by Hour (%)',
        week: 'Average Utilization by Day (%)',
      },
    },
    availability: {
      description: { last: 'Current Availability', weekDay: 'Average Availability' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Error Dur.',
      lower: 'Maintenance Dur.',
      chart: {
        day: 'Availability by Hour',
        week: 'Availability by Day',
      },
    },
  },
  DTG: {
    impression: {
      description: { last: 'Total Impressions', weekDay: 'Total Impressions' },
      statsDescription: { last: 'From last week', weekDay: 'From last week' },
      chart: {
        day: 'Total Impressions',
        week: 'Total Impressions by Day',
        custom: 'Total Impressions',
      },
      withinProductionHoursLabel: 'Production hours',
      totalLabel: 'Total Impressions',
    },
    productionRate: {
      description: { last: 'Current prod. rate', weekDay: 'Average prod. rate' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Avg. Handling Time',
      lower: 'Dark Impressions',
      chart: {
        day: 'Total Impressions by Hour',
        week: 'Average Prod. Rate by Day',
        custom: 'Average Prod. Rate',
      },
      descriptionProduction: 'Adjusted prod. rate',
    },
    utilization: {
      chart: {
        day: 'Productivity by Hour',
        week: 'Productivity by Day',
        custom: 'Productivity',
      },
      descriptionProduction: 'Adjusted Productivity',
    },
    availability: {
      description: { last: 'Current Availability', weekDay: 'Average Availability' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Error Dur.',
      lower: 'Maintenance Dur.',
      chart: {
        day: 'Availability by Hour',
        week: 'Availability by Day',
        custom: 'Availability',
      },
      descriptionProduction: 'Production Readiness',
    },
  },
  Apollo: {
    impression: {
      description: { last: 'Total Impressions', weekDay: 'Total Impressions' },
      statsDescription: { last: 'From last week', weekDay: 'From last week' },
      chart: {
        day: 'Total Impressions',
        week: 'Total Impressions by Day',
        custom: 'Total Impressions',
      },
      withinProductionHoursLabel: 'Production hours',
      totalLabel: 'Total Impressions',
    },
    productionRate: {
      description: { last: 'Current prod. rate', weekDay: 'Average prod. rate' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Avg. Handling Time',
      lower: 'Dark Impressions',
      chart: {
        day: 'Total Impressions by Hour',
        week: 'Average Prod. Rate by Day',
        custom: 'Average Prod. Rate',
      },
      descriptionProduction: 'Adjusted prod. rate',
    },
    utilization: {
      chart: {
        day: 'Productivity by Hour',
        week: 'Productivity by Day',
        custom: 'Productivity',
      },
      descriptionProduction: 'Adjusted Productivity',
    },
    availability: {
      description: { last: 'Current Availability', weekDay: 'Average Availability' },
      statsDescription: { last: 'From last hour', weekDay: 'From last week' },
      upper: 'Error Dur.',
      lower: 'Maintenance Dur.',
      chart: {
        day: 'Availability by Hour',
        week: 'Availability by Day',
        custom: 'Availability',
      },
      descriptionProduction: 'Production Readiness',
    },
  },
};
